export function AdminSidebar({ sections, active, onSelect, badges = {} }) {
  return (
    <nav data-testid="admin-sidebar" className="hidden lg:flex flex-col gap-0.5 w-[220px] shrink-0 sticky top-6 self-start max-h-[calc(100vh-3rem)] overflow-y-auto pr-2">
      {sections.map(({ v, label, Icon }) => {
        const on = active === v;
        return (
          <button
            key={v}
            type="button"
            data-testid={`admin-nav-${v}`}
            aria-current={on ? "page" : undefined}
            onClick={() => onSelect(v)}
            className={`group flex items-center gap-3 px-3 py-2.5 text-left text-sm transition-colors border-l-2 ${
              on ? "border-rose-500 bg-rose-500/10 text-white" : "border-transparent text-zinc-400 hover:text-zinc-100 hover:bg-white/5"}`}
          >
            <Icon size={15} className={on ? "text-rose-400" : "text-zinc-500 group-hover:text-zinc-300"} />
            <span className="truncate">{label}</span>
            {badges[v] ? <span className="ml-auto text-[10px] bg-rose-600 text-white px-1.5 py-0.5">{badges[v]}</span> : null}
          </button>
        );
      })}
    </nav>
  );
}

export function AdminMobileStrip({ sections, active, onSelect, badges = {} }) {
  return (
    <div data-testid="admin-mobile-nav" className="lg:hidden -mx-6 px-6 mb-4 border-b border-white/10 overflow-x-auto flex gap-1 flex-nowrap">
      {sections.map(({ v, label, Icon }) => {
        const on = active === v;
        return (
          <button
            key={v}
            type="button"
            data-testid={`admin-tab-${v}`}
            onClick={() => onSelect(v)}
            className={`shrink-0 whitespace-nowrap flex items-center gap-2 px-3 py-3 text-xs border-b-2 ${
              on ? "border-rose-600 text-white" : "border-transparent text-zinc-400"}`}
          >
            <Icon size={13} /> {label}{badges[v] ? ` (${badges[v]})` : ""}
          </button>
        );
      })}
    </div>
  );
}
